const HIDE_WELCOME = new Set([
  "Fields",
  "Wells",
  "Samples",
  "UnifiedTestView",
  "QAQCDetailSample",
  "QAQCDetailReport",
  "QAQCDetailView",
  "DifferentialLiberationSection",
  "ConstantCompositionExpansion",
  "MultiStageSeparatorTest",
  "OilViscosity",
  "Composition",
  "SampleValidation",
  "SampleInformation",
  "CvdTest",
  "OilTest",
  "GasTest",
  "AgenticDashboardAll",
  "AgenticDashboardStarred",
  "AgenticDashboardShared",
  "AgenticDashboardView",
  "EDADashboard",
  "PVTPrediction",
]);

const HIDE_CRUMBS = new Set([
  "DataManagement",
  "QAQCOverview",
  "AgenticDashboard",
  "FluidsDataStudioTwo",
  "fluidsdatapal",
  "UsersModule",
  "RolesModule",
  "EDADashboard",
]);

export const PAGE_TITLES = {
  DataManagement: "Data Management",
  Fields: "Data Management",
  Wells: "Data Management",
  Samples: "Data Management",
  QAQCIndex: "QA/QC",
  QAQCOverview: "QA/QC",
  QAQCDetailSample: "QA/QC",
  QAQCDetailReport: "QA/QC",
  QAQCDetailView: "QA/QC",
  UnifiedTestView: "QA/QC",
  FluidsDataStudioTwo: "Studio",
  AgenticDashboard: "Agentic Dashboard",
  AgenticDashboardAll: "Agentic Dashboard",
  AgenticDashboardStarred: "Agentic Dashboard",
  AgenticDashboardShared: "Agentic Dashboard",
  AgenticDashboardView: "Agentic Dashboard",
  fluidsdatapal: "Fluids Intelligence",
  PVTPrediction: "PVT Property Prediction",
  EDADashboard: "Exploratory Data Analysis (EDA)",
  DataInventoryAnalysis: "Exploratory Data Analysis (EDA)",
  CompositionChart: "Exploratory Data Analysis (EDA)",
  CorrelationAnalysis: "Exploratory Data Analysis (EDA)",
  CorrelationCoefficient: "Exploratory Data Analysis (EDA)",
  FluidsdataInsight: "Exploratory Data Analysis (EDA)",
  UsersModule: "User Management",
  RolesModule: "Role Management",
  DashboardList: "Dashboards",
  DashboardView: "Dashboards",
  DashboardCreate: "Dashboards",
  DashboardEdit: "Dashboards",
  AIMLModelling: "AI/ML Modelling",
  DataInputs: "AI/ML Modelling",
  UploadReports: "AI/ML Modelling",
  SelectData: "AI/ML Modelling",
  DataPreview: "AI/ML Modelling",
  AIMLModels: "AI/ML Modelling",
  SupervisedMLModels: "AI/ML Modelling",
  FluidsdataAIModel: "AI/ML Modelling",
  BlackOilTable: "AI/ML Modelling",
  SelectedPVTReport: "AI/ML Modelling",
  FullPVTReport: "AI/ML Modelling",
  FluidsdataBlackOilTable: "AI/ML Modelling",
  FluidsdataSelectedPVTReport: "AI/ML Modelling",
  FluidsdataFullPVTReport: "AI/ML Modelling",
  ManualDataEntry: "AI/ML Modelling",
};

export function titleForRoute(route) {
  if (PAGE_TITLES[route.name]) return PAGE_TITLES[route.name];
  const stored = localStorage.getItem("activeMenu");
  if (stored === "Exploratory Data Analysis") {
    return "Exploratory Data Analysis (EDA)";
  }
  return stored || "Data Management";
}

export function showWelcomeForRoute(route) {
  return !HIDE_WELCOME.has(route.name);
}

export function showCrumbsForRoute(route) {
  if (HIDE_CRUMBS.has(route.name)) return false;
  return true;
}
